import { NgModule } from '@angular/core';
import { TinymceComponent } from './tinymce.component';
import { HttpClientModule } from '@angular/common/http';
import { SelectImageModalComponent } from './img-upload/select-image-modal.component';
import { FileUploadModule } from 'ng2-file-upload';
import { InsertEmojiComponent } from './insert-emoji/insert-emoji.component';
import { MediaUploadComponent } from './media-upload/media-upload.component';
import { TinymceService } from './tinymce.service';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { EmojiModule } from 'clink-ui-x/emoji';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule, HttpClientModule, FileUploadModule, NzMessageModule, EmojiModule],
    providers: [TinymceService],
    declarations: [TinymceComponent, SelectImageModalComponent, InsertEmojiComponent, MediaUploadComponent],
    entryComponents: [SelectImageModalComponent],
    exports: [TinymceComponent],
})
export class TinymceModule {}
